import { Brand, Panel, secondary } from './ExperienceLayout';

export default function CreditsScreen({ onBack }) {
  return (
      <Panel wide>
        <Brand compact centered />
        <p className="mt-7 text-[10px] font-black uppercase tracking-[.25em] text-[#F7E04B]">Game La Maldición Ñaca Ñaca</p>
        <h1 className="mt-5 font-display text-[2.4rem] uppercase leading-[1.12] text-white md:text-[3rem]">Créditos</h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-[#C5E6A0]">
          Un juego de ritmo sobre Toluca: escucha, toca y mantén el pulso para maldecir cada zona.
        </p>

        <div className="mt-6 grid gap-3 text-left">
          <section className="border border-[#7EC54A]/40 bg-black/60 p-4">
            <h2 className="text-[10px] font-black uppercase tracking-[.2em] text-[#7EC54A]">Festival</h2>
            <p className="mt-3 text-sm leading-6 text-white">
              <span className="font-black">Ñaca Ñaca Festival Internacional de Cine de Terror, de la Ciudad de Toluca:</span>{' '}
              <span className="text-[#C5E6A0]">Equipo Ñaca Ñaca.</span>
            </p>
          </section>

          <section className="border border-[#F7E04B]/40 bg-black/60 p-4">
            <h2 className="text-[10px] font-black uppercase tracking-[.2em] text-[#F7E04B]">Game Colaboración</h2>
            <ul className="mt-3 space-y-2 text-sm leading-5 text-white">
              <li>
                <span className="font-black">Dirección, Diseño, Ritmo y Desarrollo:</span>{' '}
                <a href="https://lovenoho.com/" target="_blank" rel="noopener noreferrer" className="font-bold text-[#C5E6A0] underline underline-offset-4">NOHO</a>
              </li>
              <li><span className="font-black">Personajes y Ambiente:</span> <span className="text-[#C5E6A0]">Equipo Ñaca Ñaca y NOHO</span></li>
              <li><span className="font-black">Música de ambientación:</span> <span className="text-[#C5E6A0]">Ximena Contreras</span></li>
              <li><span className="font-black">Música de Juego:</span> <span className="text-[#C5E6A0]">Misael Padilla Sauceda</span></li>
            </ul>
          </section>

          <section className="border border-white/15 bg-black/40 p-4">
            <h2 className="text-[10px] font-black uppercase tracking-[.2em] text-white/80">Agradecimientos</h2>
            <p className="mt-2 text-sm leading-6 text-[#C5E6A0]">
              A quienes juegan, comparten duelos y maldicen Toluca con ritmo. Gracias por mantener viva la maldición.
            </p>
          </section>
        </div>

        <button onClick={onBack} className={`${secondary} mt-7`}>Volver al mapa</button>
      </Panel>
  );
}
